import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {IDialogFactoryService, IConfirmLugasCoolingOffLogoutDialogOptions, DialogResult} from './dialog-factory.service.interface'
import {InfoIcon} from '../../themes/defaults/icons/info.icon';
import {DialogButtonClickHandleResultEnum} from '../dialog/dialog.service.interface';
import {
    ACTION_TAKEN_NAMES,
    DISPLAY_MESSAGE_IDS,
    DISPLAY_MESSAGE_NAMES
} from "../../../common/const/casinofied-analytics-consts";

export class DialogFactoryService extends ServiceBase implements IDialogFactoryService {
    async showConfirmLugasCoolingOffLogout(options: IConfirmLugasCoolingOffLogoutDialogOptions): Promise<DialogResult> {
        const translation = this.services.translation;
        return new Promise<DialogResult>((resolve, reject) => {
            const businessCorrelationId = this.services.tools.getGuid();
            const reportClick = (action) => {
                this.services.casinofiedAnalytics.messageActionTaken({
                    businessCorrelationID:businessCorrelationId,
                    correlationID:businessCorrelationId,
                    actionType:action,
                    displayMessageName:DISPLAY_MESSAGE_NAMES.LUGAS_LOGOUT_MESSAGE_NAME
                })
            }
            this.services.dialog.showSimpleTextModal({
                title: translation.translate('UK_TSR_LOGOUT_OPT'),
                text: translation.translate('LUGAS_COOLING_OFF_LOGOUT_MESSAGE'),
                icon: (<InfoIcon />),
                hideCloseButton: false,
                buttons: [
                    {
                        text: this.services.translation.translate('CANCEL'),
                        buttonPreset: 'secondary',
                        onClick: async () => {
                            try {
                                await options.onReject();
                                reportClick(ACTION_TAKEN_NAMES.CANCEL_ACTION);
                                resolve(DialogResult.Rejected);
                            } catch (err) {
                                reject(err);
                            }

                            return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                        }
                    },
                    {
                        text: translation.translate('UK_TSR_LOGOUT_OPT'),
                        buttonPreset: 'info',
                        onClick: async () => {
                            try {
                                await options.onAccept();
                                reportClick(ACTION_TAKEN_NAMES.CONFIRM_ACTION);
                                resolve(DialogResult.Accepted);
                            } catch (err) {
                                reject(err);
                            }

                            return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                        }
                    }
                ]
            })

            this.services.casinofiedAnalytics.messageDisplay({
                businessCorrelationID:businessCorrelationId,
                correlationID:businessCorrelationId,
                displayMessageID:DISPLAY_MESSAGE_IDS.lugasLogout,
                displayMessageName:DISPLAY_MESSAGE_NAMES.LUGAS_LOGOUT_MESSAGE_NAME
            })

        })
    }
}